export const DOMAIN = 'https://maps.googleapis.com';

export const MARKER_TYPES = {
    PRICE: 'PRICE',
    TOI: 'TOI',
    POI: 'POI',
    DESTINATION: 'DESTINATION',
};

export const ControlPositions = Object.freeze({
    BOTTOM: 11,
    BOTTOM_CENTER: 11,
    BOTTOM_LEFT: 10,
    BOTTOM_RIGHT: 12,
    CENTER: 13,
    LEFT: 5,
    LEFT_BOTTOM: 6,
    LEFT_CENTER: 4,
    LEFT_TOP: 5,
    RIGHT: 7,
    RIGHT_BOTTOM: 9,
    RIGHT_CENTER: 8,
    RIGHT_TOP: 7,
    TOP: 2,
    TOP_CENTER: 2,
    TOP_LEFT: 1,
    TOP_RIGHT: 3,
});

export const APP_NAMES = {
    SERP: 'SERP',
    LANDINGAPP: 'LANDINGAPP',
    TRIPBOARDS: 'TRIPBOARDS',
    PDP: 'PDP',
};
